// @generated
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "pollDeviations", {
    enumerable: true,
    get: function() {
        return pollDeviations;
    }
});
const pollDeviations = [
    {
        deviationId: 7772494,
        typeId: 14,
        url: 'https://www.deviantart.com/misf0rtunate/poll/selfinsertsselfinsertsselfinserts-7772494',
        title: 'selfinsertsselfinsertsselfinserts',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T04:20:56-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 41292504,
            useridUuid: '02a7d020-b470-47f3-8f6c-6994f89270bf',
            username: 'MISF0RTUNATE',
            usericon: 'https://a.deviantart.net/avatars-big/m/i/misf0rtunate.png?9',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 41292504,
                useridUuid: '02a7d020-b470-47f3-8f6c-6994f89270bf',
                username: 'MISF0RTUNATE',
                usericon: 'https://a.deviantart.net/avatars-big/m/i/misf0rtunate.png?9',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772494,
            ts: '2020-01-07T04:20:56-0800',
            question: 'selfinsertsselfinsertsselfinserts',
            votes: 3,
            comments: 0,
            answers: [
                {
                    answerId: 30728015,
                    votes: 3,
                    percentvotes: 100,
                    textContent: {
                        excerpt: 'YESYESYESTHAT IS SO VALID OKAY!!!',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30728016,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'not a fan but do what you wanna do UwU',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772493,
        typeId: 14,
        url: 'https://www.deviantart.com/cmara/poll/considering-spoofing-Rabbit-Ears-productions-stories-Who-d-make-best-Anansi-7772493',
        title: "(considering spoofing Rabbit Ears productions stories) Who'd make best Anansi?",
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T04:13:48-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 2399053,
            useridUuid: 'f1c14c16-4e68-4de4-931e-c6291dbb9438',
            username: 'cmara',
            usericon: 'https://a.deviantart.net/avatars-big/c/m/cmara.png?11',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 2399053,
                useridUuid: 'f1c14c16-4e68-4de4-931e-c6291dbb9438',
                username: 'cmara',
                usericon: 'https://a.deviantart.net/avatars-big/c/m/cmara.png?11',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772493,
            ts: '2020-01-07T04:13:48-0800',
            question: "(considering spoofing Rabbit Ears productions stories) Who'd make best Anansi?",
            votes: 10,
            comments: 0,
            answers: [
                {
                    answerId: 30728012,
                    votes: 7,
                    percentvotes: 70,
                    textContent: {
                        excerpt: 'Timon (The Lion King)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30728013,
                    votes: 2,
                    percentvotes: 20,
                    textContent: {
                        excerpt: 'Jiminy Criket (Pinocchio)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30728014,
                    votes: 1,
                    percentvotes: 10,
                    textContent: {
                        excerpt: '<img src="https://e.deviantart.net/emoticons/c/confused.gif" width="15" height="30" alt=":?" data-embed-type="emoticon" data-embed-id="369" title=":? (Confused)"/> What is Anansi? (<a class="external" href="https://www.deviantart.com/users/outgoing?https://m.youtube.com/watch?v=__tPAlV_6gI&t=3033s">m.youtube.com/watch?v=__tPAlV_&hellip;</a> start at 26:59)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772492,
        typeId: 14,
        url: 'https://www.deviantart.com/nectarqenn-i/poll/Should-I-get-a-curious-at-like-does-anyone-even-look-at-those-129300-129488-7772492',
        title: 'Should I get a curious at,, like does anyone even look at those? 🤔🧐',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T04:11:08-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 46003985,
            useridUuid: 'f08074e6-ee96-40bb-9484-18f7c6ee64cd',
            username: 'nectarqenn-i',
            usericon: 'https://a.deviantart.net/avatars-big/n/e/nectarqenn-i.png?10',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 46003985,
                useridUuid: 'f08074e6-ee96-40bb-9484-18f7c6ee64cd',
                username: 'nectarqenn-i',
                usericon: 'https://a.deviantart.net/avatars-big/n/e/nectarqenn-i.png?10',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772492,
            ts: '2020-01-07T04:11:08-0800',
            question: 'Should I get a curious at,, like does anyone even look at those? 🤔🧐',
            votes: 3,
            comments: 0,
            answers: [
                {
                    answerId: 30728010,
                    votes: 2,
                    percentvotes: 67,
                    textContent: {
                        excerpt: 'Ye',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30728011,
                    votes: 1,
                    percentvotes: 33,
                    textContent: {
                        excerpt: 'Ne',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772491,
        typeId: 14,
        url: 'https://www.deviantart.com/mary-margret/poll/Which-Harley-Quin-is-your-favourite-7772491',
        title: 'Which Harley Quin is your favourite?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T04:10:00-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 16909387,
            useridUuid: '0e1416c7-4ae8-4c9d-9694-491f5f98a00b',
            username: 'Mary-Margret',
            usericon: 'https://a.deviantart.net/avatars-big/m/a/mary-margret.jpg?5',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 16909387,
                useridUuid: '0e1416c7-4ae8-4c9d-9694-491f5f98a00b',
                username: 'Mary-Margret',
                usericon: 'https://a.deviantart.net/avatars-big/m/a/mary-margret.jpg?5',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772491,
            ts: '2020-01-07T04:10:00-0800',
            question: 'Which Harley Quin is your favourite?',
            votes: 1,
            comments: 0,
            answers: [
                {
                    answerId: 30728004,
                    votes: 1,
                    percentvotes: 100,
                    deviationId: 826144373,
                    image: {
                        deviationId: 826144373,
                        typeId: 1,
                        url: 'https://www.deviantart.com/mary-margret/art/Harley-Quinn-Original-826144373',
                        title: 'Harley Quinn Original',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-01-07T03:48:15-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 16909387,
                            useridUuid: '0e1416c7-4ae8-4c9d-9694-491f5f98a00b',
                            username: 'Mary-Margret',
                            usericon: 'https://a.deviantart.net/avatars-big/m/a/mary-margret.jpg?5',
                            type: 'premium',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 0,
                            favourites: 2
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0e1416c7-4ae8-4c9d-9694-491f5f98a00b/ddnv52t-913372b9-6473-4c2e-98d0-2e713dacece0.jpg',
                            prettyName: 'harley_quinn_original_by_mary_margret_ddnv52t',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODgxIiwicGF0aCI6IlwvZlwvMGUxNDE2YzctNGFlOC00YzlkLTk2OTQtNDkxZjVmOThhMDBiXC9kZG52NTJ0LTkxMzM3MmI5LTY0NzMtNGMyZS05OGQwLTJlNzEzZGFjZWNlMC5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.S-2Tds--Puo8-4em_7a7IQI70fePYTWOvOhZPfkXhFc'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                                    h: 103,
                                    w: 150
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/fill/w_291,h_200,q_70,strp/<prettyName>-200h.jpg',
                                    h: 200,
                                    w: 291
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fit/w_300,h_881,q_70,strp/<prettyName>-300w.jpg',
                                    h: 206,
                                    w: 300
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/fill/w_363,h_250,q_70,strp/<prettyName>-250t.jpg',
                                    h: 250,
                                    w: 363
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_509,h_350,q_70,strp/<prettyName>-350t.jpg',
                                    h: 350,
                                    w: 509
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_581,h_400,q_70,strp/<prettyName>-400t.jpg',
                                    h: 400,
                                    w: 581
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078,
                                    f: 170389
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078
                                },
                                {
                                    t: 'fullview',
                                    r: 0,
                                    c: 'v1/fill/w_1280,h_881,q_75,strp/<prettyName>-fullview.jpg',
                                    h: 881,
                                    w: 1280,
                                    f: 170389
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-ask92">Original Harley</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":2,"chars":15}}]'
                        }
                    }
                },
                {
                    answerId: 30728005,
                    votes: 0,
                    percentvotes: 0,
                    deviationId: 826145198,
                    image: {
                        deviationId: 826145198,
                        typeId: 1,
                        url: 'https://www.deviantart.com/mary-margret/art/Harley-Quinn-mark-2-826145198',
                        title: 'Harley Quinn mark 2',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-01-07T03:53:13-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 16909387,
                            useridUuid: '0e1416c7-4ae8-4c9d-9694-491f5f98a00b',
                            username: 'Mary-Margret',
                            usericon: 'https://a.deviantart.net/avatars-big/m/a/mary-margret.jpg?5',
                            type: 'premium',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 0,
                            favourites: 5
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0e1416c7-4ae8-4c9d-9694-491f5f98a00b/ddnv5pq-4338b36d-ee12-42bb-95d7-8ea9ee94c28b.jpg',
                            prettyName: 'harley_quinn_mark_2_by_mary_margret_ddnv5pq',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODg2IiwicGF0aCI6IlwvZlwvMGUxNDE2YzctNGFlOC00YzlkLTk2OTQtNDkxZjVmOThhMDBiXC9kZG52NXBxLTQzMzhiMzZkLWVlMTItNDJiYi05NWQ3LThlYTllZTk0YzI4Yi5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.qNjqFeoj5DM9RYze8uOJ3kbJk5pSV6iSqxd-fjb2vHk'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                                    h: 104,
                                    w: 150
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/fill/w_289,h_200,q_70,strp/<prettyName>-200h.jpg',
                                    h: 200,
                                    w: 289
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fit/w_300,h_886,q_70,strp/<prettyName>-300w.jpg',
                                    h: 208,
                                    w: 300
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/fill/w_361,h_250,q_70,strp/<prettyName>-250t.jpg',
                                    h: 250,
                                    w: 361
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_506,h_350,q_70,strp/<prettyName>-350t.jpg',
                                    h: 350,
                                    w: 506
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_578,h_400,q_70,strp/<prettyName>-400t.jpg',
                                    h: 400,
                                    w: 578
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_1075,h_744,q_70,strp/<prettyName>-pre.jpg',
                                    h: 744,
                                    w: 1075,
                                    f: 169138
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_1075,h_744,q_70,strp/<prettyName>-pre.jpg',
                                    h: 744,
                                    w: 1075
                                },
                                {
                                    t: 'fullview',
                                    r: 0,
                                    c: 'v1/fill/w_1280,h_886,q_75,strp/<prettyName>-fullview.jpg',
                                    h: 886,
                                    w: 1280,
                                    f: 169138
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-98rru">Harley mark 2, revived look</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":4,"chars":27}}]'
                        }
                    }
                },
                {
                    answerId: 30728006,
                    votes: 0,
                    percentvotes: 0,
                    deviationId: 826145391,
                    image: {
                        deviationId: 826145391,
                        typeId: 1,
                        url: 'https://www.deviantart.com/mary-margret/art/Harley-Quinn-mark-3-826145391',
                        title: 'Harley Quinn mark 3',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-01-07T03:56:02-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 16909387,
                            useridUuid: '0e1416c7-4ae8-4c9d-9694-491f5f98a00b',
                            username: 'Mary-Margret',
                            usericon: 'https://a.deviantart.net/avatars-big/m/a/mary-margret.jpg?5',
                            type: 'premium',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 0,
                            favourites: 3
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0e1416c7-4ae8-4c9d-9694-491f5f98a00b/ddnv5v3-fad706d4-fda0-4126-84f6-ecdbc0b74541.jpg',
                            prettyName: 'harley_quinn_mark_3_by_mary_margret_ddnv5v3',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODgzIiwicGF0aCI6IlwvZlwvMGUxNDE2YzctNGFlOC00YzlkLTk2OTQtNDkxZjVmOThhMDBiXC9kZG52NXYzLWZhZDcwNmQ0LWZkYTAtNDEyNi04NGY2LWVjZGJjMGI3NDU0MS5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.3bHMOVcAP6pWxN1hxJjBKWoSpp7QDPx77GEBKx4vzbE'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                                    h: 103,
                                    w: 150
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/fill/w_290,h_200,q_70,strp/<prettyName>-200h.jpg',
                                    h: 200,
                                    w: 290
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fit/w_300,h_883,q_70,strp/<prettyName>-300w.jpg',
                                    h: 207,
                                    w: 300
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/fill/w_363,h_250,q_70,strp/<prettyName>-250t.jpg',
                                    h: 250,
                                    w: 362
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_508,h_350,q_70,strp/<prettyName>-350t.jpg',
                                    h: 350,
                                    w: 507
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_580,h_400,q_70,strp/<prettyName>-400t.jpg',
                                    h: 400,
                                    w: 580
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_1076,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1076,
                                    f: 174698
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_1076,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1076
                                },
                                {
                                    t: 'fullview',
                                    r: 0,
                                    c: 'v1/fill/w_1280,h_883,q_75,strp/<prettyName>-fullview.jpg',
                                    h: 883,
                                    w: 1280,
                                    f: 174698
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-40hl0">Harley mark 3, video game</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":4,"chars":25}}]'
                        }
                    }
                },
                {
                    answerId: 30728007,
                    votes: 0,
                    percentvotes: 0,
                    deviationId: 826145511,
                    image: {
                        deviationId: 826145511,
                        typeId: 1,
                        url: 'https://www.deviantart.com/mary-margret/art/Harley-Quinn-Suicide-Squad-826145511',
                        title: 'Harley Quinn Suicide Squad',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-01-07T03:58:40-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 16909387,
                            useridUuid: '0e1416c7-4ae8-4c9d-9694-491f5f98a00b',
                            username: 'Mary-Margret',
                            usericon: 'https://a.deviantart.net/avatars-big/m/a/mary-margret.jpg?5',
                            type: 'premium',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 0,
                            favourites: 3
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0e1416c7-4ae8-4c9d-9694-491f5f98a00b/ddnv5yf-76d9ec4d-9d23-4ea3-92c7-180a2647700e.jpg',
                            prettyName: 'harley_quinn_suicide_squad_by_mary_margret_ddnv5yf',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODgxIiwicGF0aCI6IlwvZlwvMGUxNDE2YzctNGFlOC00YzlkLTk2OTQtNDkxZjVmOThhMDBiXC9kZG52NXlmLTc2ZDllYzRkLTlkMjMtNGVhMy05MmM3LTE4MGEyNjQ3NzAwZS5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.DzeHfB0Vd-S8u2Nl7WCPws7Mty5mqci5OHQi37zocVk'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                                    h: 103,
                                    w: 150
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/fill/w_291,h_200,q_70,strp/<prettyName>-200h.jpg',
                                    h: 200,
                                    w: 291
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fit/w_300,h_881,q_70,strp/<prettyName>-300w.jpg',
                                    h: 206,
                                    w: 300
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/fill/w_363,h_250,q_70,strp/<prettyName>-250t.jpg',
                                    h: 250,
                                    w: 363
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_509,h_350,q_70,strp/<prettyName>-350t.jpg',
                                    h: 350,
                                    w: 509
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_581,h_400,q_70,strp/<prettyName>-400t.jpg',
                                    h: 400,
                                    w: 581
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078,
                                    f: 199160
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078
                                },
                                {
                                    t: 'fullview',
                                    r: 0,
                                    c: 'v1/fill/w_1280,h_881,q_75,strp/<prettyName>-fullview.jpg',
                                    h: 881,
                                    w: 1280,
                                    f: 199160
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-3m4cs">Suicide Squad Harley</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":3,"chars":20}}]'
                        }
                    }
                },
                {
                    answerId: 30728008,
                    votes: 0,
                    percentvotes: 0,
                    deviationId: 826145634,
                    image: {
                        deviationId: 826145634,
                        typeId: 1,
                        url: 'https://www.deviantart.com/mary-margret/art/Harley-Quinn-Birds-of-Prey-826145634',
                        title: 'Harley Quinn Birds of Prey',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-01-07T04:02:17-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 16909387,
                            useridUuid: '0e1416c7-4ae8-4c9d-9694-491f5f98a00b',
                            username: 'Mary-Margret',
                            usericon: 'https://a.deviantart.net/avatars-big/m/a/mary-margret.jpg?5',
                            type: 'premium',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 0,
                            favourites: 2
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0e1416c7-4ae8-4c9d-9694-491f5f98a00b/ddnv61u-5e8e8e76-3ce3-4b4d-b90f-9265e03a3b37.jpg',
                            prettyName: 'harley_quinn_birds_of_prey_by_mary_margret_ddnv61u',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODgxIiwicGF0aCI6IlwvZlwvMGUxNDE2YzctNGFlOC00YzlkLTk2OTQtNDkxZjVmOThhMDBiXC9kZG52NjF1LTVlOGU4ZTc2LTNjZTMtNGI0ZC1iOTBmLTkyNjVlMDNhM2IzNy5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.YF_jrLcybP05CLgK5fyEBaIgZ7vkX7V8kAcsBDVfUKA'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                                    h: 103,
                                    w: 150
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/fill/w_291,h_200,q_70,strp/<prettyName>-200h.jpg',
                                    h: 200,
                                    w: 291
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fit/w_300,h_881,q_70,strp/<prettyName>-300w.jpg',
                                    h: 206,
                                    w: 300
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/fill/w_363,h_250,q_70,strp/<prettyName>-250t.jpg',
                                    h: 250,
                                    w: 363
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_509,h_350,q_70,strp/<prettyName>-350t.jpg',
                                    h: 350,
                                    w: 509
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_581,h_400,q_70,strp/<prettyName>-400t.jpg',
                                    h: 400,
                                    w: 581
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078,
                                    f: 218640
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078
                                },
                                {
                                    t: 'fullview',
                                    r: 0,
                                    c: 'v1/fill/w_1280,h_881,q_75,strp/<prettyName>-fullview.jpg',
                                    h: 881,
                                    w: 1280,
                                    f: 218640
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-2nnm0">New Birds of Prey Harley</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":5,"chars":24}}]'
                        }
                    }
                },
                {
                    answerId: 30728009,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-6q708">Other? Leave comment</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":3,"chars":20}}]'
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772490,
        typeId: 14,
        url: 'https://www.deviantart.com/simon-the-umbreon/poll/What-am-I-to-you-7772490',
        title: 'What am I to you?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T04:04:26-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 36643498,
            useridUuid: '7721e713-38ec-42b9-a859-1aafe2e68324',
            username: 'Simon-the-Umbreon',
            usericon: 'https://a.deviantart.net/avatars-big/s/i/simon-the-umbreon.png?10',
            type: 'beta',
            isNewDeviant: false
        },
        stats: {
            comments: 2,
            favourites: 0
        },
        poll: {
            user: {
                userId: 36643498,
                useridUuid: '7721e713-38ec-42b9-a859-1aafe2e68324',
                username: 'Simon-the-Umbreon',
                usericon: 'https://a.deviantart.net/avatars-big/s/i/simon-the-umbreon.png?10',
                type: 'beta',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772490,
            ts: '2020-01-07T04:04:26-0800',
            question: 'What am I to you?',
            votes: 1,
            comments: 2,
            answers: [
                {
                    answerId: 30728000,
                    votes: 1,
                    percentvotes: 100,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-cvgb6">Friend</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":6}}]'
                        }
                    }
                },
                {
                    answerId: 30728001,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-f0niq">I only like your art</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":5,"chars":20}}]'
                        }
                    }
                },
                {
                    answerId: 30728002,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-dareq">Bro</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":3}}]'
                        }
                    }
                },
                {
                    answerId: 30728003,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-2amcl">Who are you?</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":3,"chars":12}}]'
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772489,
        typeId: 14,
        url: 'https://www.deviantart.com/k-dsan/poll/You-lost-the-one-you-really-really-really-really-really-loved-but-you-could-choose-something-odd-to-happen-what-would-you-choose-7772489',
        title: 'You lost the one you really really really really really loved, but you could choose something odd to happen, what would you choose?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:58:21-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30102507,
            useridUuid: '9a9b59e4-8117-4a16-823c-4d56d30d05ba',
            username: 'k-dsan',
            usericon: 'https://a.deviantart.net/avatars-big/k/_/k-dsan.jpg?13',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 30102507,
                useridUuid: '9a9b59e4-8117-4a16-823c-4d56d30d05ba',
                username: 'k-dsan',
                usericon: 'https://a.deviantart.net/avatars-big/k/_/k-dsan.jpg?13',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772489,
            ts: '2020-01-07T03:58:21-0800',
            question: 'You lost the one you really really really really really loved, but you could choose something odd to happen, what would you choose?',
            votes: 0,
            comments: 0,
            answers: [
                {
                    answerId: 30727994,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Having her/him soul back even with different appearance (her/his soul inside someone else&#8217;s body).',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727995,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Having her/him back even though its someone else&#8217;s soul inside her/his body.',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727996,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Letting her/him go and finding another soulmate with the same traits of her./him',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727997,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Finding someone else completely different than her/him since I don&#8217;t want be remembered of her/him anymore.',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727998,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Stay single.',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772488,
        typeId: 14,
        url: 'https://www.deviantart.com/socepath/poll/May-do-a-free-raffle-idk-What-would-be-the-most-appealing-prize-for-you-7772488',
        title: 'May do a "free raffle" idk. What would be the most appealing prize for you?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:57:53-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 43741312,
            useridUuid: '18100078-f27b-499c-9c2f-8382627bc639',
            username: 'Socepath',
            usericon: 'https://a.deviantart.net/avatars-big/s/o/socepath.png?13',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 43741312,
                useridUuid: '18100078-f27b-499c-9c2f-8382627bc639',
                username: 'Socepath',
                usericon: 'https://a.deviantart.net/avatars-big/s/o/socepath.png?13',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772488,
            ts: '2020-01-07T03:57:53-0800',
            question: 'May do a "free raffle" idk. What would be the most appealing prize for you?',
            votes: 11,
            comments: 0,
            answers: [
                {
                    answerId: 30727988,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Shaded fullbody (one winner)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727989,
                    votes: 6,
                    percentvotes: 55,
                    textContent: {
                        excerpt: '(Shaded?) Headshot/bust (up to 10 winners)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727990,
                    votes: 1,
                    percentvotes: 9,
                    textContent: {
                        excerpt: 'Ref sheet (one winner)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727991,
                    votes: 2,
                    percentvotes: 18,
                    textContent: {
                        excerpt: 'Custom design (up to 3 winners)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727992,
                    votes: 2,
                    percentvotes: 18,
                    textContent: {
                        excerpt: 'Sketchpage (one winner)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727993,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Other (comment your suggestion)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772487,
        typeId: 14,
        url: 'https://www.deviantart.com/amazonbattlegrounds2/poll/Battlefield-Germany-what-should-Happen-next-7772487',
        title: 'Battlefield Germany: what should Happen next?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:54:20-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 45379379,
            useridUuid: '7d502764-d674-4019-89d7-30261738a10f',
            username: 'AmazonBattlegrounds2',
            usericon: 'https://a.deviantart.net/avatars-big/a/m/amazonbattlegrounds2.jpg?4',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 45379379,
                useridUuid: '7d502764-d674-4019-89d7-30261738a10f',
                username: 'AmazonBattlegrounds2',
                usericon: 'https://a.deviantart.net/avatars-big/a/m/amazonbattlegrounds2.jpg?4',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772487,
            ts: '2020-01-07T03:54:20-0800',
            question: 'Battlefield Germany: what should Happen next?',
            votes: 3,
            comments: 0,
            answers: [
                {
                    answerId: 30727982,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'An unit of US-soldier Girls attacking the the Russin supply Camp and get slaughtered',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727983,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'An unit of US-soldier Girls attacking the the Russin supply Camp and kill all Russin formale soldiers',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727984,
                    votes: 1,
                    percentvotes: 33,
                    textContent: {
                        excerpt: 'An east-frisian supply convoy, protected by 25 OSK fighters,gets attacked by 12 russian Girl soldiers. All russian get slaughtered.',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727985,
                    votes: 1,
                    percentvotes: 33,
                    textContent: {
                        excerpt: 'An east-frisian supply convoy, protected by 25 OSK fighters,gets attacked by 12 russian Girl soldiers. All German OSK women die.',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727986,
                    votes: 1,
                    percentvotes: 33,
                    textContent: {
                        excerpt: 'A Brunch of east-frisian Male civilans wants Revenge: they Attack the russian supply Camp and slaughter all russian Girl soldiers',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727987,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'A Brunch of east-frisian Male civilans wants Revenge: they Attack the russian supply Camp and all got killed by the girls',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772486,
        typeId: 14,
        url: 'https://www.deviantart.com/huntingpeople/poll/So-I-confirmed-that-Firefox-was-the-problem-but-now-there-are-new-problems-7772486',
        title: 'So I confirmed that Firefox was the problem, but now there are new problems',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:52:32-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 38664054,
            useridUuid: 'e15503a0-8d4b-4123-acd0-debed67c1f73',
            username: 'HuntingPeople',
            usericon: 'https://a.deviantart.net/avatars-big/h/u/huntingpeople.png?7',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 1,
            favourites: 0
        },
        poll: {
            user: {
                userId: 38664054,
                useridUuid: 'e15503a0-8d4b-4123-acd0-debed67c1f73',
                username: 'HuntingPeople',
                usericon: 'https://a.deviantart.net/avatars-big/h/u/huntingpeople.png?7',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772486,
            ts: '2020-01-07T03:52:32-0800',
            question: 'So I confirmed that Firefox was the problem, but now there are new problems',
            votes: 0,
            comments: 1,
            answers: [
                {
                    answerId: 30727981,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: "Computer won't let me download chrome and I can't fucking listen to anything =')))))))",
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772485,
        typeId: 14,
        url: 'https://www.deviantart.com/lefen/poll/whats-the-coolest-to-u-7772485',
        title: 'whats the coolest to u',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:52:02-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 42639357,
            useridUuid: 'd1f4aedc-31cb-446a-86d1-2c8f513a117b',
            username: 'Lefen',
            usericon: 'https://a.deviantart.net/avatars-big/l/e/lefen.png?3',
            type: 'beta',
            isNewDeviant: false
        },
        stats: {
            comments: 1,
            favourites: 0
        },
        poll: {
            user: {
                userId: 42639357,
                useridUuid: 'd1f4aedc-31cb-446a-86d1-2c8f513a117b',
                username: 'Lefen',
                usericon: 'https://a.deviantart.net/avatars-big/l/e/lefen.png?3',
                type: 'beta',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772485,
            ts: '2020-01-07T03:52:02-0800',
            question: 'whats the coolest to u',
            votes: 2,
            comments: 1,
            answers: [
                {
                    answerId: 30727971,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'planets',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727972,
                    votes: 1,
                    percentvotes: 50,
                    textContent: {
                        excerpt: 'stars (all type)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727973,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'supernovas',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727974,
                    votes: 1,
                    percentvotes: 50,
                    textContent: {
                        excerpt: 'black holes',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727975,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'dark matter',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727976,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'nebulae',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727977,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'galaxies &amp; superclusters',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727978,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'cosmic voids',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727979,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'worm &amp; white holes (hypothetical)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727980,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'i dont care shts abt space so im gonna choose portals',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772484,
        typeId: 14,
        url: 'https://www.deviantart.com/sierii/poll/What-commission-style-would-you-be-more-interested-in-7772484',
        title: 'What commission style would you be more interested in:',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:47:52-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 41752836,
            useridUuid: '700a30f4-3de6-4951-ae5f-6cbcfb416e9e',
            username: 'sierii',
            usericon: 'https://a.deviantart.net/avatars-big/s/i/sierii.gif?13',
            type: 'beta',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 41752836,
                useridUuid: '700a30f4-3de6-4951-ae5f-6cbcfb416e9e',
                username: 'sierii',
                usericon: 'https://a.deviantart.net/avatars-big/s/i/sierii.gif?13',
                type: 'beta',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772484,
            ts: '2020-01-07T03:47:52-0800',
            question: 'What commission style would you be more interested in:',
            votes: 4,
            comments: 0,
            answers: [
                {
                    answerId: 30727966,
                    votes: 1,
                    percentvotes: 25,
                    textContent: {
                        excerpt: 'B/W Sketch Headshots - 350 points',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727967,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Sketch Chibis - 500 points',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727968,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Sticker Chibis - 1200 points',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727969,
                    votes: 1,
                    percentvotes: 25,
                    textContent: {
                        excerpt: 'Coloured Sketch Headshots - 450 points',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727970,
                    votes: 1,
                    percentvotes: 25,
                    textContent: {
                        excerpt: 'Other (please let me know through the comments or through notes)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727999,
                    votes: 1,
                    percentvotes: 25,
                    textContent: {
                        excerpt: "I can't buy (can't afford)/ Not interested",
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772483,
        typeId: 14,
        url: 'https://www.deviantart.com/legoanimatronics33/poll/What-do-you-want-to-see-This-will-be-deleted-by-the-end-of-the-week-7772483',
        title: 'What do you want to see? (This will be deleted by the end of the week.)',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:37:44-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 42069294,
            useridUuid: '820460c6-5548-4fa0-86d9-0757464c67e6',
            username: 'LegoAnimatronics33',
            usericon: 'https://a.deviantart.net/avatars-big/l/e/legoanimatronics33.png?1',
            type: 'regular',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 42069294,
                useridUuid: '820460c6-5548-4fa0-86d9-0757464c67e6',
                username: 'LegoAnimatronics33',
                usericon: 'https://a.deviantart.net/avatars-big/l/e/legoanimatronics33.png?1',
                type: 'regular',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772483,
            ts: '2020-01-07T03:37:44-0800',
            question: 'What do you want to see? (This will be deleted by the end of the week.)',
            votes: 1,
            comments: 0,
            answers: [
                {
                    answerId: 30727963,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-b0164">Make free downloadable stuff for 3D programs <a href="https://www.deviantart.com/kittenlover75/art/Five-Nights-at-Freddy-s-SL-Bon-Bon-Idle-663779802"><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1479c766-9d77-4569-ac18-3af253beaa68/daz73ru-4b671215-8d8d-4601-9373-07f855d4d0c4.gif" alt="Five Nights at Freddy\'s: SL - Bon-Bon Idle" width="50" height="50" /></a> </div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":1,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":7,"chars":46}}]'
                        }
                    }
                },
                {
                    answerId: 30727964,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-1rn67">more LEGOs<a href="https://www.deviantart.com/gksrhkdtmd/art/Unikitty-gif-animation-718964136"><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/3fbc54cf-d9eb-4a73-b7fe-3e3fb5b53508/dbw1wa0-6922b75d-21d1-461e-92ea-31c110ab996f.gif" alt="Unikitty (gif animation)" width="50" height="50" /></a> </div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":1,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":2,"chars":11}}]'
                        }
                    }
                },
                {
                    answerId: 30727965,
                    votes: 1,
                    percentvotes: 100,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-3ttin">MEMES!<a href="https://www.deviantart.com/mrfinicky/art/When-the-Meme-is-Just-Right-671661717"><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/b62ab400-e0b3-4ef6-943a-eb8da34b312f/db3w1hx-76d889fd-f481-4bb9-9406-6b2c79c3380b.gif" alt="When the Meme is Just Right" width="50" height="50" /></a> </div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":1,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":7}}]'
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772482,
        typeId: 14,
        url: 'https://www.deviantart.com/bvzzkill/poll/Opinion-on-lewd-nsfw-art-7772482',
        title: 'Opinion on lewd/nsfw art?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:32:11-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 48701457,
            useridUuid: 'b5364cf3-fadc-49fd-a150-5d3c5eef04c6',
            username: 'bvzzkill',
            usericon: 'https://a.deviantart.net/avatars-big/b/v/bvzzkill.jpg?8',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 3,
            favourites: 0
        },
        poll: {
            user: {
                userId: 48701457,
                useridUuid: 'b5364cf3-fadc-49fd-a150-5d3c5eef04c6',
                username: 'bvzzkill',
                usericon: 'https://a.deviantart.net/avatars-big/b/v/bvzzkill.jpg?8',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772482,
            ts: '2020-01-07T03:32:11-0800',
            question: 'Opinion on lewd/nsfw art?',
            votes: 25,
            comments: 3,
            answers: [
                {
                    answerId: 30727957,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Burn it &#128563;&#128293;&#128293;&#128293;&#128293;',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727958,
                    votes: 7,
                    percentvotes: 28,
                    textContent: {
                        excerpt: 'Don&#8217;t wanna see it/not a fan',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727959,
                    votes: 8,
                    percentvotes: 32,
                    textContent: {
                        excerpt: 'Don&#8217;t really care about it/don&#8217;t mind it',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727960,
                    votes: 3,
                    percentvotes: 12,
                    textContent: {
                        excerpt: 'I like it but I don&#8217;t draw it',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727961,
                    votes: 7,
                    percentvotes: 28,
                    textContent: {
                        excerpt: 'I like it and I draw it',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727962,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Other? (comment :&gt;)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772481,
        typeId: 14,
        url: 'https://www.deviantart.com/igaaori/poll/Watchers-Raffle-ends-on-9th-January-https-www-deviantart-com-igaaori-journal-Watchers-Art-Raffle-OPEN-825543705-7772481',
        title: 'Watchers Raffle ends on 9th January! https://www.deviantart.com/igaaori/journal/Watchers-Art-Raffle-OPEN-825543705',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:27:46-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 39034631,
            useridUuid: '228f2a48-5d87-42d5-97d2-3bf14c9e1e3a',
            username: 'IgaAori',
            usericon: 'https://a.deviantart.net/avatars-big/i/g/igaaori.gif?6',
            type: 'regular',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 39034631,
                useridUuid: '228f2a48-5d87-42d5-97d2-3bf14c9e1e3a',
                username: 'IgaAori',
                usericon: 'https://a.deviantart.net/avatars-big/i/g/igaaori.gif?6',
                type: 'regular',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772481,
            ts: '2020-01-07T03:27:46-0800',
            question: 'Watchers Raffle ends on 9th January! https://www.deviantart.com/igaaori/journal/Watchers-Art-Raffle-OPEN-825543705',
            votes: 12,
            comments: 0,
            answers: [
                {
                    answerId: 30727955,
                    votes: 11,
                    percentvotes: 92,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-e9e9a">I am in!</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":3,"chars":8}}]'
                        }
                    }
                },
                {
                    answerId: 30727956,
                    votes: 1,
                    percentvotes: 8,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-ft3r4">Too much work to advertise it...</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":6,"chars":32}}]'
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772480,
        typeId: 14,
        url: 'https://www.deviantart.com/dragonitavioleta/poll/Right-or-left-handed-7772480',
        title: 'Right or left handed?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:27:19-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 31434223,
            useridUuid: '5461be8a-9ed1-47a3-9ddd-7e111e4f978e',
            username: 'DragonitaVioleta',
            usericon: 'https://a.deviantart.net/avatars-big/d/r/dragonitavioleta.jpg?4',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 31434223,
                useridUuid: '5461be8a-9ed1-47a3-9ddd-7e111e4f978e',
                username: 'DragonitaVioleta',
                usericon: 'https://a.deviantart.net/avatars-big/d/r/dragonitavioleta.jpg?4',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772480,
            ts: '2020-01-07T03:27:19-0800',
            question: 'Right or left handed?',
            votes: 8,
            comments: 0,
            answers: [
                {
                    answerId: 30727952,
                    votes: 8,
                    percentvotes: 100,
                    textContent: {
                        excerpt: 'Right',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727953,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Left',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727954,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'I can do both! <img src="https://e.deviantart.net/emoticons/e/eek.gif" width="15" height="15" alt=":o" data-embed-type="emoticon" data-embed-id="375" title=":o (Eek)"/>',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772479,
        typeId: 14,
        url: 'https://www.deviantart.com/karackachileena/poll/Which-topping-would-you-add-to-your-burger-7772479',
        title: 'Which topping would you add to your burger?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:26:43-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 38630638,
            useridUuid: '061548eb-3628-4db8-932f-a4943eae800a',
            username: 'Karackachileena',
            usericon: 'https://a.deviantart.net/avatars-big/k/a/karackachileena.jpg?4',
            type: 'regular',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 38630638,
                useridUuid: '061548eb-3628-4db8-932f-a4943eae800a',
                username: 'Karackachileena',
                usericon: 'https://a.deviantart.net/avatars-big/k/a/karackachileena.jpg?4',
                type: 'regular',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772479,
            ts: '2020-01-07T03:26:43-0800',
            question: 'Which topping would you add to your burger?',
            votes: 0,
            comments: 0,
            answers: [
                {
                    answerId: 30727948,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-4lm62">Pickles</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":7}}]'
                        }
                    }
                },
                {
                    answerId: 30727949,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-fvs0d">Onions</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":6}}]'
                        }
                    }
                },
                {
                    answerId: 30727950,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-6f99p">Both</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":4}}]'
                        }
                    }
                },
                {
                    answerId: 30727951,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-7ao5f">Neither</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":7}}]'
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772478,
        typeId: 14,
        url: 'https://www.deviantart.com/frost-rime/poll/Should-I-do-base-edit-commissions-7772478',
        title: 'Should I do base edit commissions?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T03:04:08-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 48513713,
            useridUuid: 'bc963f9b-ce99-40d4-b606-b0db63ce0335',
            username: 'Frost-Rime',
            usericon: 'https://a.deviantart.net/avatars-big/f/r/frost-rime.png?1',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 2,
            favourites: 0
        },
        poll: {
            user: {
                userId: 48513713,
                useridUuid: 'bc963f9b-ce99-40d4-b606-b0db63ce0335',
                username: 'Frost-Rime',
                usericon: 'https://a.deviantart.net/avatars-big/f/r/frost-rime.png?1',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772478,
            ts: '2020-01-07T03:04:08-0800',
            question: 'Should I do base edit commissions?',
            votes: 5,
            comments: 2,
            answers: [
                {
                    answerId: 30727946,
                    votes: 5,
                    percentvotes: 100,
                    textContent: {
                        excerpt: 'yes',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727947,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'no',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772477,
        typeId: 14,
        url: 'https://www.deviantart.com/nerdy-pixel-girl/poll/Free-art-7772477',
        title: 'Free art~',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T02:58:44-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 29751520,
            useridUuid: '1d9059de-ffc4-4479-9fcf-03972a53ab72',
            username: 'Nerdy-pixel-girl',
            usericon: 'https://a.deviantart.net/avatars-big/n/e/nerdy-pixel-girl.gif?8',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 2,
            favourites: 0
        },
        poll: {
            user: {
                userId: 29751520,
                useridUuid: '1d9059de-ffc4-4479-9fcf-03972a53ab72',
                username: 'Nerdy-pixel-girl',
                usericon: 'https://a.deviantart.net/avatars-big/n/e/nerdy-pixel-girl.gif?8',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772477,
            ts: '2020-01-07T02:58:44-0800',
            question: 'Free art~',
            votes: 0,
            comments: 2,
            answers: [
                {
                    answerId: 30727945,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<span class="shadow-holder" data-embed-type="deviation" data-embed-id="826141871" data-embed-format="thumb"><span class="shadow mild" ><a href="https://www.deviantart.com/nerdy-pixel-girl/journal/NEW-free-pixel-art-requests-826141871" data-sigil="thumb" class="thumb lit" onmouseover="if (window.LitBox) LitBox.hover(this, true)" onmouseout="if (window.LitBox) LitBox.out(this)"><i></i><img class="lit journal" src="https://st.deviantart.net/minish/gruzecontrol/icons/journal.gif?2"><span class="wrap" style="width: 150px"><q>\n        <strong>NEW free pixel art requests</strong><strong><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/28507ac7-8043-4476-a6fd-6cade4a29995/ddlupxc-e14a7c87-c37a-4528-9aa4-e30a9171ca50.gif?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzI4NTA3YWM3LTgwNDMtNDQ3Ni1hNmZkLTZjYWRlNGEyOTk5NVwvZGRsdXB4Yy1lMTRhN2M4Ny1jMzdhLTQ1MjgtOWFhNC1lMzBhOTE3MWNhNTAuZ2lmIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.c6yhyZINLaZfN6cGydMWzykqT3E-jjpxNZBzaXQY-yU" alt="Cat Meow Thurston Waffles" style="width:50px;height:50px"><br />&nbsp;You can request free art here, the reason I made a new journal is that so few people followed the rules on my last one, so I had to hide almost every comment on it.<br /></strong><br /><strong><br /><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/db95d15b-8c0c-4bb6-b743-1beb61737925/d9raw4y-db75dc7a-8f4f-48de-8b68-f8c60905e5e5.gif" alt="Miku Love [V1]" style="width:50px;height:50px">&nbsp;If you left any comments on the old journal they still count, but you can re-comment here if you like.<br /></strong><br /><strong><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/9d1f14cd-316a-4c4f-9e49-9e66162f5fde/ddb0fcx-451ee006-bcc3-47f6-8ef6-bed8b6337bb4.gif?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzlkMWYxNGNkLTMxNmEtNGM0Zi05ZTQ5LTllNjYxNjJmNWZkZVwvZGRiMGZjeC00NTFlZTAwNi1iY2MzLTQ3ZjYtOGVmNi1iZWQ4YjYzMzdiYjQuZ2lmIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.WLiMP3CK6XhLzUOKar9rh5cUGDrUwzahlmhR-FFOY0A" alt="Batman Finger Wag" style="width:50px;height:50px">&nbsp;This is NOT first come first serve!<br /><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/733397bc-09e0-4e23-ab7f-27aeddb9cd05/dc4fh37-74c31c25-8b4d-44c6-8067-79f30a8b16e3.gif" alt="My Melody Emoji: Sorry!" style="width:50px;height:50px">&nbsp;I cannot do all OC\'s, please don\'t be offended if I don\'t pick yours!<br /><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/cc129c8c-6efc-4694-967c-8821ffd00baa/d8bt315-549f7494-c283-43b5-bb13-ee5ed8ab6903.gif" alt="Yuuko Laughing Icon" style="width:50px;height:50px">&nbsp;I choose the style, pose, base, etc for the OC(s) in question.</strong><br /><strong><br />EXAMPLES:<img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1d9059de-ffc4-4479-9fcf-03972a53ab72/datt38c-be504a11-3f06-420a-8774-12aead0025d6.png/v1/fit/w_300,h_399,strp/nellie_the_naga_nf2u_by_nerdy_pixel_girl_datt38c-300w.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Mzk5IiwicGF0aCI6IlwvZlwvMWQ5MDU5ZGUtZmZjNC00NDc5LTlmY2YtMDM5NzJhNTNhYjcyXC9kYXR0MzhjLWJlNTA0YTExLTNmMDYtNDIwYS04Nzc0LTEyYWVhZDAwMjVkNi5wbmciLCJ3aWR0aCI6Ijw9MzE1In1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.lWDGLqkCNx1jGqUOjMly0DcsbI7GWiYOQMRPmz58P64"class="gr-shrink thumb-in-thumb ">&nbsp;<img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1d9059de-ffc4-4479-9fcf-03972a53ab72/dbfaikf-27483ef4-7460-4ba3-ab0b-6cd8da63a605.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFkOTA1OWRlLWZmYzQtNDQ3OS05ZmNmLTAzOTcyYTUzYWI3MlwvZGJmYWlrZi0yNzQ4M2VmNC03NDYwLTRiYTMtYWIwYi02Y2Q4ZGE2M2E2MDUucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.nlHmmUvXy2q4u0eN3rZs8OocdY6uCKbs1lkX8dVCC-Q"class="gr-shrink thumb-in-thumb "><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1d9059de-ffc4-4479-9fcf-03972a53ab72/dd7rn7a-8a411057-f319-4934-aff0-f17370c4b39a.png"class="gr-shrink thumb-in-thumb "><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1d9059de-ffc4-4479-9fcf-03972a53ab72/dd88yvu-e1ef8e36-b79b-4fad-970a-895ae32df25d.png/v1/fit/w_300,h_167,strp/kingdom_hearts_merfolk_f2u_by_nerdy_pixel_girl_dd88yvu-300w.png"class="gr-shrink thumb-in-thumb "><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1d9059de-ffc4-4479-9fcf-03972a53ab72/dcgs2ib-d85287be-e455-4383-a165-66277ac026fb.png"class="gr-shrink thumb-in-thumb "><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1d9059de-ffc4-4479-9fcf-03972a53ab72/da9j7p5-c6664733-fbb4-4e26-ac37-2c741f9e5419.png"class="gr-shrink thumb-in-thumb "><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1d9059de-ffc4-4479-9fcf-03972a53ab72/dbszhtt-b418785d-82cc-446b-b7de-3de14c247501.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFkOTA1OWRlLWZmYzQtNDQ3OS05ZmNmLTAzOTcyYTUzYWI3MlwvZGJzemh0dC1iNDE4Nzg1ZC04MmNjLTQ0NmItYjdkZS0zZGUxNGMyNDc1MDEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.a34kbqoLle9_E6Ish7TN_ZLepueJ3Xf6uDK_lb3IXDk"class="gr-shrink thumb-in-thumb "></strong></q></span></a></span><!-- ^TTT --><!-- TTT$ --></span>',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772476,
        typeId: 14,
        url: 'https://www.deviantart.com/lions-notice/poll/new-ocs-sonas-what-do-i-do-7772476',
        title: 'new ocs/sonas, what do i do',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T02:51:20-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 37016632,
            useridUuid: '84c2bbbb-dab5-424b-8ec4-63805aee8d33',
            username: 'Lions-Notice',
            usericon: 'https://a.deviantart.net/avatars-big/l/i/lions-notice.png?8',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 37016632,
                useridUuid: '84c2bbbb-dab5-424b-8ec4-63805aee8d33',
                username: 'Lions-Notice',
                usericon: 'https://a.deviantart.net/avatars-big/l/i/lions-notice.png?8',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772476,
            ts: '2020-01-07T02:51:20-0800',
            question: 'new ocs/sonas, what do i do',
            votes: 2,
            comments: 0,
            answers: [
                {
                    answerId: 30727941,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'seuss sona bcus i saw some other ppl do it',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727942,
                    votes: 1,
                    percentvotes: 50,
                    textContent: {
                        excerpt: 'steven universe gemsona',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727943,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'smile for me OC',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727944,
                    votes: 1,
                    percentvotes: 50,
                    textContent: {
                        excerpt: 'stop procrastinating and make a new ref for your main sona u coward',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772475,
        typeId: 14,
        url: 'https://www.deviantart.com/purenai/poll/purenai-should-try-7772475',
        title: 'purenai should try:',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T02:45:37-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 1370661,
            useridUuid: '1cf12f8c-19ae-409e-bc33-b8cc83b821b3',
            username: 'purenai',
            usericon: 'https://a.deviantart.net/avatars-big/p/u/purenai.jpg?3',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 1370661,
                useridUuid: '1cf12f8c-19ae-409e-bc33-b8cc83b821b3',
                username: 'purenai',
                usericon: 'https://a.deviantart.net/avatars-big/p/u/purenai.jpg?3',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772475,
            ts: '2020-01-07T02:45:37-0800',
            question: 'purenai should try:',
            votes: 5,
            comments: 0,
            answers: [
                {
                    answerId: 30727938,
                    votes: 2,
                    percentvotes: 40,
                    textContent: {
                        excerpt: "80's/90's anime style.",
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727939,
                    votes: 2,
                    percentvotes: 40,
                    textContent: {
                        excerpt: 'retro/synthwave style.',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727940,
                    votes: 1,
                    percentvotes: 20,
                    textContent: {
                        excerpt: 'pixel pagedoll/icon.',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772474,
        typeId: 14,
        url: 'https://www.deviantart.com/firefoxgirl96/poll/result-from-the-last-poll-only-1-type-of-commission-my-question-what-type-of-commission-7772474',
        title: 'result from the last poll: only 1 type of commission. my question: what type of commission?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T02:29:02-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 38468916,
            useridUuid: '1880c4ab-6a35-481e-8ced-c5bc3483f076',
            username: 'Firefoxgirl96',
            usericon: 'https://a.deviantart.net/avatars-big/f/i/firefoxgirl96.png?7',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 38468916,
                useridUuid: '1880c4ab-6a35-481e-8ced-c5bc3483f076',
                username: 'Firefoxgirl96',
                usericon: 'https://a.deviantart.net/avatars-big/f/i/firefoxgirl96.png?7',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772474,
            ts: '2020-01-07T02:29:02-0800',
            question: 'result from the last poll: only 1 type of commission. my question: what type of commission?',
            votes: 0,
            comments: 0,
            answers: [
                {
                    answerId: 30727934,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Pixel?',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727935,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'Digital?',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727936,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'traditional?',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727937,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: 'other (comment)',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772473,
        typeId: 14,
        url: 'https://www.deviantart.com/aspenattack/poll/Is-Dedede-the-king-of-the-show-7772473',
        title: 'Is Dedede the king of the show?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T02:27:22-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 44592741,
            useridUuid: '77a64805-6fc0-4991-af71-78829f1cb544',
            username: 'AspenAttack',
            usericon: 'https://a.deviantart.net/avatars-big/a/s/aspenattack.png?12',
            type: 'regular',
            isNewDeviant: false
        },
        stats: {
            comments: 1,
            favourites: 0
        },
        poll: {
            user: {
                userId: 44592741,
                useridUuid: '77a64805-6fc0-4991-af71-78829f1cb544',
                username: 'AspenAttack',
                usericon: 'https://a.deviantart.net/avatars-big/a/s/aspenattack.png?12',
                type: 'regular',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772473,
            ts: '2020-01-07T02:27:22-0800',
            question: 'Is Dedede the king of the show?',
            votes: 3,
            comments: 1,
            answers: [
                {
                    answerId: 30727929,
                    votes: 1,
                    percentvotes: 33,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-20ik">Yes!</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":4}}]'
                        }
                    }
                },
                {
                    answerId: 30727930,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-3ldqq">Absolutely.</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":11}}]'
                        }
                    }
                },
                {
                    answerId: 30727931,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-a6a2d">Without a doubt.</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":3,"chars":16}}]'
                        }
                    }
                },
                {
                    answerId: 30727932,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-ca000">No (illegal)</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":2,"chars":12}}]'
                        }
                    }
                },
                {
                    answerId: 30727933,
                    votes: 2,
                    percentvotes: 67,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-8du8a">*Laughs in Penguin*</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":3,"chars":19}}]'
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772472,
        typeId: 14,
        url: 'https://www.deviantart.com/bladeofdoom22/poll/Witch-one-of-my-predators-of-story-s-you-like-the-best-7772472',
        title: "Witch one of my predators of story's you like the best",
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T02:20:19-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30225041,
            useridUuid: '0a57e133-3750-44b5-a91e-39f6ae4c9249',
            username: 'bladeofdoom22',
            usericon: 'https://a.deviantart.net/avatars-big/b/l/bladeofdoom22.jpg?3',
            type: 'regular',
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        poll: {
            user: {
                userId: 30225041,
                useridUuid: '0a57e133-3750-44b5-a91e-39f6ae4c9249',
                username: 'bladeofdoom22',
                usericon: 'https://a.deviantart.net/avatars-big/b/l/bladeofdoom22.jpg?3',
                type: 'regular',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7772472,
            ts: '2020-01-07T02:20:19-0800',
            question: "Witch one of my predators of story's you like the best",
            votes: 0,
            comments: 0,
            answers: [
                {
                    answerId: 30867566,
                    votes: 0,
                    percentvotes: 0,
                    deviationId: 829682000,
                    image: {
                        deviationId: 829682000,
                        typeId: 1,
                        url: 'https://www.deviantart.com/phqbia/art/boba-cat-COM-829682000',
                        title: 'boba cat!! (COM)',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-02-07T18:32:06-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 47978502,
                            useridUuid: 'b4adf667-48b3-472f-a5d9-5d9dcb78c241',
                            username: 'phqbia',
                            usericon: 'https://a.deviantart.net/avatars-big/p/h/phqbia.png?15',
                            type: 'regular',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 4,
                            favourites: 4
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/b4adf667-48b3-472f-a5d9-5d9dcb78c241/ddpyyq8-d7ea31a9-7015-4f15-9e71-134aeb70740a.png',
                            prettyName: 'boba_cat____com__by_phqbia_ddpyyq8',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDg0IiwicGF0aCI6IlwvZlwvYjRhZGY2NjctNDhiMy00NzJmLWE1ZDktNWQ5ZGNiNzhjMjQxXC9kZHB5eXE4LWQ3ZWEzMWE5LTcwMTUtNGYxNS05ZTcxLTEzNGFlYjcwNzQwYS5wbmciLCJ3aWR0aCI6Ijw9MzY0In1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0._15OCnwpKKt3dVRj8mFsMbQ2reXSLQcMNsvpYwNXkKo',
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2I0YWRmNjY3LTQ4YjMtNDcyZi1hNWQ5LTVkOWRjYjc4YzI0MVwvZGRweXlxOC1kN2VhMzFhOS03MDE1LTRmMTUtOWU3MS0xMzRhZWI3MDc0MGEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.LKDhXeScdzM0zxfISNPNG2jfFjS59y1vORY9KzzrJh4'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                                    h: 150,
                                    w: 113,
                                    o: true
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/crop/w_150,h_200,x_0,y_0,scl_0.41483516483516,strp/<prettyName>-200h.png',
                                    h: 200,
                                    w: 150,
                                    o: true
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fit/w_300,h_484,strp/<prettyName>-300w.png',
                                    h: 399,
                                    w: 300,
                                    o: true
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/fill/w_188,h_250,strp/<prettyName>-250t.png',
                                    h: 250,
                                    w: 188,
                                    o: true
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_263,h_350,strp/<prettyName>-350t.png',
                                    h: 350,
                                    w: 263,
                                    o: true
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_301,h_400,strp/<prettyName>-400t.png',
                                    h: 400,
                                    w: 301,
                                    o: true
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_364,h_484,strp/<prettyName>-fullview.png',
                                    h: 484,
                                    w: 364,
                                    o: true,
                                    f: 120285
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_364,h_484,strp/<prettyName>-fullview.png',
                                    h: 484,
                                    w: 364,
                                    o: true
                                },
                                {
                                    t: 'fullview',
                                    r: 1,
                                    h: 484,
                                    w: 364,
                                    o: true,
                                    f: 120285
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-8ek43">haha jk.......</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":2,"chars":14}}]'
                        }
                    }
                },
                {
                    answerId: 30867567,
                    votes: 0,
                    percentvotes: 0,
                    deviationId: 829732735,
                    image: {
                        deviationId: 829732735,
                        typeId: 1,
                        url: 'https://www.deviantart.com/phqbia/art/babey-829732735',
                        title: 'babey',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-02-08T07:14:26-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 47978502,
                            useridUuid: 'b4adf667-48b3-472f-a5d9-5d9dcb78c241',
                            username: 'phqbia',
                            usericon: 'https://a.deviantart.net/avatars-big/p/h/phqbia.png?15',
                            type: 'regular',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 1,
                            favourites: 4
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/b4adf667-48b3-472f-a5d9-5d9dcb78c241/ddq01vj-4408d2a4-00f4-4968-bde0-f604ed7106be.png',
                            prettyName: 'babey_by_phqbia_ddq01vj',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzIwIiwicGF0aCI6IlwvZlwvYjRhZGY2NjctNDhiMy00NzJmLWE1ZDktNWQ5ZGNiNzhjMjQxXC9kZHEwMXZqLTQ0MDhkMmE0LTAwZjQtNDk2OC1iZGUwLWY2MDRlZDcxMDZiZS5wbmciLCJ3aWR0aCI6Ijw9MjU4In1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.FoRr72Lu1hpmYUevJefMDl4K0HcqYXnuhGf3Y7Cxc54',
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2I0YWRmNjY3LTQ4YjMtNDcyZi1hNWQ5LTVkOWRjYjc4YzI0MVwvZGRxMDF2ai00NDA4ZDJhNC0wMGY0LTQ5NjgtYmRlMC1mNjA0ZWQ3MTA2YmUucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.1Fbl8_72Umi17ZKTbHLcqSkMEDFC0exlExj7AwYy11A'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                                    h: 150,
                                    w: 121,
                                    o: true
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/fill/w_161,h_200,strp/<prettyName>-200h.png',
                                    h: 200,
                                    w: 161,
                                    o: true
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fill/w_258,h_320,strp/<prettyName>-fullview.png',
                                    h: 320,
                                    w: 258,
                                    o: true
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/crop/w_202,h_250,x_0,y_0,scl_0.78294573643411,strp/<prettyName>-250t.png',
                                    h: 250,
                                    w: 202,
                                    o: true
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_258,h_320,strp/<prettyName>-fullview.png',
                                    h: 320,
                                    w: 258,
                                    o: true
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_258,h_320,strp/<prettyName>-fullview.png',
                                    h: 320,
                                    w: 258,
                                    o: true
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_258,h_320,strp/<prettyName>-fullview.png',
                                    h: 320,
                                    w: 258,
                                    o: true,
                                    f: 62466
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_258,h_320,strp/<prettyName>-fullview.png',
                                    h: 320,
                                    w: 258,
                                    o: true
                                },
                                {
                                    t: 'fullview',
                                    r: 1,
                                    h: 320,
                                    w: 258,
                                    o: true,
                                    f: 62466
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-2r2c8">unless?... <a href="https://www.deviantart.com/67fatz/art/burps-809227475"><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/3df876c1-dbd1-4ae5-af1f-a158e64bb298/dddsjwz-e8f5e008-d1aa-40c9-89da-ea595e177714.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzNkZjg3NmMxLWRiZDEtNGFlNS1hZjFmLWExNThlNjRiYjI5OFwvZGRkc2p3ei1lOGY1ZTAwOC1kMWFhLTQwYzktODlkYS1lYTU5NWUxNzc3MTQucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.fCpueBajRirv_GW3liAtaVuVcz4CwFI1rWx6jqnrUjo" alt="burps" width="50" height="50" /></a> </div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":1,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":15}}]'
                        }
                    }
                },
                {
                    answerId: 30867568,
                    votes: 1,
                    percentvotes: 100,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-38t71">lena stop copying iceberg-</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":4,"chars":26}}]'
                        }
                    }
                },
                {
                    answerId: 30867569,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-dnhrh">YOU DONT EVEN LIKE ECLIPSE???? I????M???</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":7,"chars":40}}]'
                        }
                    }
                },
                {
                    answerId: 30867570,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-ad4h4">why are the commissions the icons ((psst,,, i dont know ))</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":10,"chars":59}}]'
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7772471,
        typeId: 14,
        url: 'https://www.deviantart.com/huntingpeople/poll/hI-I-M-GENUINELY-FUCKING-TERRIFIED-7772471',
        title: "hI, I'M GENUINELY FUCKING TERRIFIED",
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-01-07T02:19:50-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 38664054,
            useridUuid: 'e15503a0-8d4b-4123-acd0-debed67c1f73',
            username: 'HuntingPeople',
            usericon: 'https://a.deviantart.net/avatars-big/h/u/huntingpeople.png?7',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 4,
            favourites: 0
        },
        poll: {
            user: {
                userId: 38664054,
                useridUuid: 'e15503a0-8d4b-4123-acd0-debed67c1f73',
                username: 'HuntingPeople',
                usericon: 'https://a.deviantart.net/avatars-big/h/u/huntingpeople.png?7',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: true,
            votedAnswerid: 30727922,
            pollId: 7772471,
            ts: '2020-01-07T02:19:50-0800',
            question: "hI, I'M GENUINELY FUCKING TERRIFIED",
            votes: 1,
            comments: 4,
            answers: [
                {
                    answerId: 30727922,
                    votes: 1,
                    percentvotes: 100,
                    textContent: {
                        excerpt: "If I drop off the face of the Earth, it's because I genuinely believe my computer could pack up at any moment",
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727923,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: "I THINK I've figured out what the issue is (And that is opening Firefox so right now, I'm using internet explorer, if there's a better browser I can download PLEASE LET ME KNOW)",
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727924,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: "uH, yeah, I THINK that's the issue, but it might not be, and considering that this laptop seems to be on her last legs now, I might just go ahead and buy a new one anyway???",
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30727925,
                    votes: 0,
                    percentvotes: 0,
                    textContent: {
                        excerpt: "UH YEAH, JUST KEEP THAT IN MIND IF I LITERALLY DON'T POST ANYTHING FOR LIKE 48+ HOURS",
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7807861,
        typeId: 14,
        url: 'https://www.deviantart.com/redfired0g/poll/Do-you-use-Eclipse-view-or-the-classic-version-of-the-website-7807861',
        title: 'Do you use Eclipse view, or the classic version of the website?',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-02-26T12:24:44-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 3634311,
            useridUuid: '628a62b9-a0b8-4a2c-b57d-396928479839',
            username: 'RedFireD0g',
            usericon: 'https://a.deviantart.net/avatars-big/r/e/redfired0g.jpg?14',
            type: 'premium',
            isNewDeviant: false
        },
        stats: {
            comments: 3,
            favourites: 0
        },
        poll: {
            user: {
                userId: 3634311,
                useridUuid: '628a62b9-a0b8-4a2c-b57d-396928479839',
                username: 'RedFireD0g',
                usericon: 'https://a.deviantart.net/avatars-big/r/e/redfired0g.jpg?14',
                type: 'premium',
                isNewDeviant: false
            },
            hasVoted: true,
            votedAnswerid: 30868938,
            pollId: 7807861,
            ts: '2020-02-26T12:24:44-0800',
            question: 'Do you use Eclipse view, or the classic version of the website?',
            votes: 107,
            comments: 3,
            answers: [
                {
                    answerId: 30868938,
                    votes: 9,
                    percentvotes: 8,
                    deviationId: 826144373,
                    image: {
                        deviationId: 826144373,
                        typeId: 1,
                        url: 'https://www.deviantart.com/mary-margret/art/Harley-Quinn-Original-826144373',
                        title: 'Harley Quinn Original',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-01-07T03:48:15-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 16909387,
                            useridUuid: '0e1416c7-4ae8-4c9d-9694-491f5f98a00b',
                            username: 'Mary-Margret',
                            usericon: 'https://a.deviantart.net/avatars-big/m/a/mary-margret.jpg?5',
                            type: 'premium',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 0,
                            favourites: 2
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0e1416c7-4ae8-4c9d-9694-491f5f98a00b/ddnv52t-913372b9-6473-4c2e-98d0-2e713dacece0.jpg',
                            prettyName: 'harley_quinn_original_by_mary_margret_ddnv52t',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODgxIiwicGF0aCI6IlwvZlwvMGUxNDE2YzctNGFlOC00YzlkLTk2OTQtNDkxZjVmOThhMDBiXC9kZG52NTJ0LTkxMzM3MmI5LTY0NzMtNGMyZS05OGQwLTJlNzEzZGFjZWNlMC5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.S-2Tds--Puo8-4em_7a7IQI70fePYTWOvOhZPfkXhFc'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                                    h: 103,
                                    w: 150
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/fill/w_291,h_200,q_70,strp/<prettyName>-200h.jpg',
                                    h: 200,
                                    w: 291
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fit/w_300,h_881,q_70,strp/<prettyName>-300w.jpg',
                                    h: 206,
                                    w: 300
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/fill/w_363,h_250,q_70,strp/<prettyName>-250t.jpg',
                                    h: 250,
                                    w: 363
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_509,h_350,q_70,strp/<prettyName>-350t.jpg',
                                    h: 350,
                                    w: 509
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_581,h_400,q_70,strp/<prettyName>-400t.jpg',
                                    h: 400,
                                    w: 581
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078,
                                    f: 170389
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078
                                },
                                {
                                    t: 'fullview',
                                    r: 0,
                                    c: 'v1/fill/w_1280,h_881,q_75,strp/<prettyName>-fullview.jpg',
                                    h: 881,
                                    w: 1280,
                                    f: 170389
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: 'Eclipse! But lets make this a very very very very long answer, so that we can test what happens when people write answers like these, with a lot of words',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30868939,
                    votes: 92,
                    percentvotes: 86,
                    deviationId: 826144373,
                    image: {
                        deviationId: 826144373,
                        typeId: 1,
                        url: 'https://www.deviantart.com/mary-margret/art/Harley-Quinn-Original-826144373',
                        title: 'Harley Quinn Original',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-01-07T03:48:15-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 16909387,
                            useridUuid: '0e1416c7-4ae8-4c9d-9694-491f5f98a00b',
                            username: 'Mary-Margret',
                            usericon: 'https://a.deviantart.net/avatars-big/m/a/mary-margret.jpg?5',
                            type: 'premium',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 0,
                            favourites: 2
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0e1416c7-4ae8-4c9d-9694-491f5f98a00b/ddnv52t-913372b9-6473-4c2e-98d0-2e713dacece0.jpg',
                            prettyName: 'harley_quinn_original_by_mary_margret_ddnv52t',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODgxIiwicGF0aCI6IlwvZlwvMGUxNDE2YzctNGFlOC00YzlkLTk2OTQtNDkxZjVmOThhMDBiXC9kZG52NTJ0LTkxMzM3MmI5LTY0NzMtNGMyZS05OGQwLTJlNzEzZGFjZWNlMC5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.S-2Tds--Puo8-4em_7a7IQI70fePYTWOvOhZPfkXhFc'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                                    h: 103,
                                    w: 150
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/fill/w_291,h_200,q_70,strp/<prettyName>-200h.jpg',
                                    h: 200,
                                    w: 291
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fit/w_300,h_881,q_70,strp/<prettyName>-300w.jpg',
                                    h: 206,
                                    w: 300
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/fill/w_363,h_250,q_70,strp/<prettyName>-250t.jpg',
                                    h: 250,
                                    w: 363
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_509,h_350,q_70,strp/<prettyName>-350t.jpg',
                                    h: 350,
                                    w: 509
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_581,h_400,q_70,strp/<prettyName>-400t.jpg',
                                    h: 400,
                                    w: 581
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078,
                                    f: 170389
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078
                                },
                                {
                                    t: 'fullview',
                                    r: 0,
                                    c: 'v1/fill/w_1280,h_881,q_75,strp/<prettyName>-fullview.jpg',
                                    h: 881,
                                    w: 1280,
                                    f: 170389
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: 'Classic!',
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                },
                {
                    answerId: 30868940,
                    votes: 6,
                    percentvotes: 6,
                    deviationId: 826144373,
                    image: {
                        deviationId: 826144373,
                        typeId: 1,
                        url: 'https://www.deviantart.com/mary-margret/art/Harley-Quinn-Original-826144373',
                        title: 'Harley Quinn Original',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-01-07T03:48:15-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 16909387,
                            useridUuid: '0e1416c7-4ae8-4c9d-9694-491f5f98a00b',
                            username: 'Mary-Margret',
                            usericon: 'https://a.deviantart.net/avatars-big/m/a/mary-margret.jpg?5',
                            type: 'premium',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 0,
                            favourites: 2
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0e1416c7-4ae8-4c9d-9694-491f5f98a00b/ddnv52t-913372b9-6473-4c2e-98d0-2e713dacece0.jpg',
                            prettyName: 'harley_quinn_original_by_mary_margret_ddnv52t',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODgxIiwicGF0aCI6IlwvZlwvMGUxNDE2YzctNGFlOC00YzlkLTk2OTQtNDkxZjVmOThhMDBiXC9kZG52NTJ0LTkxMzM3MmI5LTY0NzMtNGMyZS05OGQwLTJlNzEzZGFjZWNlMC5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.S-2Tds--Puo8-4em_7a7IQI70fePYTWOvOhZPfkXhFc'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                                    h: 103,
                                    w: 150
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/fill/w_291,h_200,q_70,strp/<prettyName>-200h.jpg',
                                    h: 200,
                                    w: 291
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fit/w_300,h_881,q_70,strp/<prettyName>-300w.jpg',
                                    h: 206,
                                    w: 300
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/fill/w_363,h_250,q_70,strp/<prettyName>-250t.jpg',
                                    h: 250,
                                    w: 363
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_509,h_350,q_70,strp/<prettyName>-350t.jpg',
                                    h: 350,
                                    w: 509
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_581,h_400,q_70,strp/<prettyName>-400t.jpg',
                                    h: 400,
                                    w: 581
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078,
                                    f: 170389
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_1078,h_742,q_70,strp/<prettyName>-pre.jpg',
                                    h: 742,
                                    w: 1078
                                },
                                {
                                    t: 'fullview',
                                    r: 0,
                                    c: 'v1/fill/w_1280,h_881,q_75,strp/<prettyName>-fullview.jpg',
                                    h: 881,
                                    w: 1280,
                                    f: 170389
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: "Long long long answer, let's see what happens, hopefully it wont break our UI, but if it does we'll fix it",
                        html: {
                            type: 'writer',
                            features: ''
                        }
                    }
                }
            ]
        }
    },
    {
        deviationId: 7807519,
        typeId: 14,
        url: 'https://www.deviantart.com/phqbia/poll/what-if-i-made-a-poll-in-eclipse-mode-7807519',
        title: 'what if i made a poll in eclipse mode',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2020-02-25T23:09:38-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 47978502,
            useridUuid: 'b4adf667-48b3-472f-a5d9-5d9dcb78c241',
            username: 'phqbia',
            usericon: 'https://a.deviantart.net/avatars-big/p/h/phqbia.png?15',
            type: 'regular',
            isNewDeviant: false
        },
        stats: {
            comments: 1,
            favourites: 0
        },
        poll: {
            user: {
                userId: 47978502,
                useridUuid: 'b4adf667-48b3-472f-a5d9-5d9dcb78c241',
                username: 'phqbia',
                usericon: 'https://a.deviantart.net/avatars-big/p/h/phqbia.png?15',
                type: 'regular',
                isNewDeviant: false
            },
            hasVoted: false,
            pollId: 7807519,
            ts: '2020-02-25T23:09:38-0800',
            question: 'what if i made a poll in eclipse mode',
            votes: 1,
            comments: 1,
            answers: [
                {
                    answerId: 30867566,
                    votes: 0,
                    percentvotes: 0,
                    deviationId: 829682000,
                    image: {
                        deviationId: 829682000,
                        typeId: 1,
                        url: 'https://www.deviantart.com/phqbia/art/boba-cat-COM-829682000',
                        title: 'boba cat!! (COM)',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-02-07T18:32:06-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 47978502,
                            useridUuid: 'b4adf667-48b3-472f-a5d9-5d9dcb78c241',
                            username: 'phqbia',
                            usericon: 'https://a.deviantart.net/avatars-big/p/h/phqbia.png?15',
                            type: 'regular',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 4,
                            favourites: 4
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/b4adf667-48b3-472f-a5d9-5d9dcb78c241/ddpyyq8-d7ea31a9-7015-4f15-9e71-134aeb70740a.png',
                            prettyName: 'boba_cat____com__by_phqbia_ddpyyq8',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDg0IiwicGF0aCI6IlwvZlwvYjRhZGY2NjctNDhiMy00NzJmLWE1ZDktNWQ5ZGNiNzhjMjQxXC9kZHB5eXE4LWQ3ZWEzMWE5LTcwMTUtNGYxNS05ZTcxLTEzNGFlYjcwNzQwYS5wbmciLCJ3aWR0aCI6Ijw9MzY0In1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0._15OCnwpKKt3dVRj8mFsMbQ2reXSLQcMNsvpYwNXkKo',
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2I0YWRmNjY3LTQ4YjMtNDcyZi1hNWQ5LTVkOWRjYjc4YzI0MVwvZGRweXlxOC1kN2VhMzFhOS03MDE1LTRmMTUtOWU3MS0xMzRhZWI3MDc0MGEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.LKDhXeScdzM0zxfISNPNG2jfFjS59y1vORY9KzzrJh4'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                                    h: 150,
                                    w: 113,
                                    o: true
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/crop/w_150,h_200,x_0,y_0,scl_0.41483516483516,strp/<prettyName>-200h.png',
                                    h: 200,
                                    w: 150,
                                    o: true
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fit/w_300,h_484,strp/<prettyName>-300w.png',
                                    h: 399,
                                    w: 300,
                                    o: true
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/fill/w_188,h_250,strp/<prettyName>-250t.png',
                                    h: 250,
                                    w: 188,
                                    o: true
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_263,h_350,strp/<prettyName>-350t.png',
                                    h: 350,
                                    w: 263,
                                    o: true
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_301,h_400,strp/<prettyName>-400t.png',
                                    h: 400,
                                    w: 301,
                                    o: true
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_364,h_484,strp/<prettyName>-fullview.png',
                                    h: 484,
                                    w: 364,
                                    o: true,
                                    f: 120285
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_364,h_484,strp/<prettyName>-fullview.png',
                                    h: 484,
                                    w: 364,
                                    o: true
                                },
                                {
                                    t: 'fullview',
                                    r: 1,
                                    h: 484,
                                    w: 364,
                                    o: true,
                                    f: 120285
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-8ek43">haha jk.......</div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":2,"chars":14}}]'
                        }
                    }
                },
                {
                    answerId: 30867567,
                    votes: 0,
                    percentvotes: 0,
                    deviationId: 829732735,
                    image: {
                        deviationId: 829732735,
                        typeId: 1,
                        url: 'https://www.deviantart.com/phqbia/art/babey-829732735',
                        title: 'babey',
                        isJournal: false,
                        isPurchasable: false,
                        publishedTime: '2020-02-08T07:14:26-0800',
                        isTextEditable: false,
                        legacyTextEditUrl: null,
                        isShareable: true,
                        isCommentable: true,
                        isFavourited: false,
                        isDeleted: false,
                        isMature: false,
                        isDownloadable: true,
                        isAntisocial: false,
                        isBlocked: false,
                        isPublished: true,
                        blockReasons: [],
                        author: {
                            userId: 47978502,
                            useridUuid: 'b4adf667-48b3-472f-a5d9-5d9dcb78c241',
                            username: 'phqbia',
                            usericon: 'https://a.deviantart.net/avatars-big/p/h/phqbia.png?15',
                            type: 'regular',
                            isNewDeviant: false
                        },
                        stats: {
                            comments: 1,
                            favourites: 4
                        },
                        media: {
                            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/b4adf667-48b3-472f-a5d9-5d9dcb78c241/ddq01vj-4408d2a4-00f4-4968-bde0-f604ed7106be.png',
                            prettyName: 'babey_by_phqbia_ddq01vj',
                            token: [
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzIwIiwicGF0aCI6IlwvZlwvYjRhZGY2NjctNDhiMy00NzJmLWE1ZDktNWQ5ZGNiNzhjMjQxXC9kZHEwMXZqLTQ0MDhkMmE0LTAwZjQtNDk2OC1iZGUwLWY2MDRlZDcxMDZiZS5wbmciLCJ3aWR0aCI6Ijw9MjU4In1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.FoRr72Lu1hpmYUevJefMDl4K0HcqYXnuhGf3Y7Cxc54',
                                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2I0YWRmNjY3LTQ4YjMtNDcyZi1hNWQ5LTVkOWRjYjc4YzI0MVwvZGRxMDF2ai00NDA4ZDJhNC0wMGY0LTQ5NjgtYmRlMC1mNjA0ZWQ3MTA2YmUucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.1Fbl8_72Umi17ZKTbHLcqSkMEDFC0exlExj7AwYy11A'
                            ],
                            types: [
                                {
                                    t: '150',
                                    r: 0,
                                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                                    h: 150,
                                    w: 121,
                                    o: true
                                },
                                {
                                    t: '200H',
                                    r: 0,
                                    c: 'v1/fill/w_161,h_200,strp/<prettyName>-200h.png',
                                    h: 200,
                                    w: 161,
                                    o: true
                                },
                                {
                                    t: '300W',
                                    r: 0,
                                    c: 'v1/fill/w_258,h_320,strp/<prettyName>-fullview.png',
                                    h: 320,
                                    w: 258,
                                    o: true
                                },
                                {
                                    t: '250T',
                                    r: 0,
                                    c: 'v1/crop/w_202,h_250,x_0,y_0,scl_0.78294573643411,strp/<prettyName>-250t.png',
                                    h: 250,
                                    w: 202,
                                    o: true
                                },
                                {
                                    t: '350T',
                                    r: 0,
                                    c: 'v1/fill/w_258,h_320,strp/<prettyName>-fullview.png',
                                    h: 320,
                                    w: 258,
                                    o: true
                                },
                                {
                                    t: '400T',
                                    r: 0,
                                    c: 'v1/fill/w_258,h_320,strp/<prettyName>-fullview.png',
                                    h: 320,
                                    w: 258,
                                    o: true
                                },
                                {
                                    t: 'preview',
                                    r: 0,
                                    c: 'v1/fill/w_258,h_320,strp/<prettyName>-fullview.png',
                                    h: 320,
                                    w: 258,
                                    o: true,
                                    f: 62466
                                },
                                {
                                    t: 'social_preview',
                                    r: 0,
                                    c: 'v1/fill/w_258,h_320,strp/<prettyName>-fullview.png',
                                    h: 320,
                                    w: 258,
                                    o: true
                                },
                                {
                                    t: 'fullview',
                                    r: 1,
                                    h: 320,
                                    w: 258,
                                    o: true,
                                    f: 62466
                                }
                            ]
                        }
                    },
                    textContent: {
                        excerpt: '<div class="daeditor-fluid"><div class="daeditor-paragraph" id="djs-2r2c8">unless?... <a href="https://www.deviantart.com/67fatz/art/burps-809227475"><img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/3df876c1-dbd1-4ae5-af1f-a158e64bb298/dddsjwz-e8f5e008-d1aa-40c9-89da-ea595e177714.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzNkZjg3NmMxLWRiZDEtNGFlNS1hZjFmLWExNThlNjRiYjI5OFwvZGRkc2p3ei1lOGY1ZTAwOC1kMWFhLTQwYzktODlkYS1lYTU5NWUxNzc3MTQucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.fCpueBajRirv_GW3liAtaVuVcz4CwFI1rWx6jqnrUjo" alt="burps" width="50" height="50" /></a> </div></div>',
                        html: {
                            type: 'draft',
                            features: '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":1,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":15}}]'
                        }
                    }
                }
            ]
        }
    }
];
